import {
  GET_DISCOVERY_REVIEWS,
  GET_DISCOVERY_REVIEW_DETAILS,
  GET_DISCOVERY_REVIEW_DETAILS_FAILED,
  GET_DISCOVERY_REVIEW_DETAILS_SUCCESS,
  GET_DISCOVERY_REVIEWS_FAILED,
  GET_DISCOVERY_REVIEWS_SUCCESS,
  CLEANUP_DISCOVER_REVIEW_DETAILS,
  CLEANUP_DISCOVER_REVIEWS,
  DELETE_DISCOVERY_REVIEW,
  DELETE_DISCOVERY_REVIEW_SUCCESS,
  DELETE_DISCOVERY_REVIEW_FAILED,
} from './actionTypes';

const initialState = {
  reviews: { data: [], total: 0 },
  reviewsLoading: true,

  reviewDetails: {},
  reviewDetailsLoading: true,

  deleteDiscoveryReviewLoading: false,
};

export default function discoverReview(state = initialState, action) {
  switch (action.type) {
    // GET_DISCOVERY_REVIEW_DETAILS
    case GET_DISCOVERY_REVIEW_DETAILS:
      return {
        ...state,
        reviewDetailsLoading: true,
      };

    case GET_DISCOVERY_REVIEW_DETAILS_SUCCESS:
      return {
        ...state,
        reviewDetailsLoading: false,
        reviewDetails: action.payload,
      };

    case GET_DISCOVERY_REVIEW_DETAILS_FAILED:
      return {
        ...state,
        reviewDetailsLoading: false,
      };

    case CLEANUP_DISCOVER_REVIEW_DETAILS:
      return {
        ...state,
        reviewDetailsLoading: true,
        reviewDetails: {},
      };

    // GET_DISCOVERY_REVIEWS
    case GET_DISCOVERY_REVIEWS:
      return {
        ...state,
        reviewsLoading: true,
      };

    case GET_DISCOVERY_REVIEWS_SUCCESS:
      return {
        ...state,
        reviewsLoading: false,
        reviews: action.payload,
      };

    case GET_DISCOVERY_REVIEWS_FAILED:
      return {
        ...state,
        reviewsLoading: false,
      };

    case CLEANUP_DISCOVER_REVIEWS:
      return {
        ...state,
        reviewsLoading: true,
        reviews: { data: [], total: 0 },
      };

    // DELETE_DISCOVERY_REVIEW
    case DELETE_DISCOVERY_REVIEW:
      return {
        ...state,
        deleteDiscoveryReviewLoading: true,
      };
    case DELETE_DISCOVERY_REVIEW_SUCCESS: {
      const newReviews = state.reviews.data.map((review) => {
        if (review._id === action.payload) {
          return {
            ...review,
            isDeleted: true,
            deletedAt: review.deletedAt ? null : new Date(),
          };
        }

        return review;
      });

      return {
        ...state,
        deleteDiscoveryReviewLoading: false,
        reviews: {
          ...state.reviews,
          data: newReviews,
        },
      };
    }
    case DELETE_DISCOVERY_REVIEW_FAILED:
      return {
        ...state,
        deleteDiscoveryReviewLoading: false,
      };

    default: return state;
  }
}
